import { LESSONS_PER_PAGE } from '@/dictionary';
import api from '@/services/api/api';

export const useLessons = (page) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const { canEditLessons } = useLessonAccess();

  const lessons = useQuery(
    ['lessons', page],
    async () => {
      const { data } = await api.lessons.getLessons({
        per_page: LESSONS_PER_PAGE,
        page: toValue(page),
      });
      return data;
    },
    {
      enabled: canEditLessons,
      staleTime: Infinity,
      keepPreviousData: true,
      refetchOnMount: true,
    },
  );

  const createLesson = useMutation(
    async ({ title, materials }) => {
      const { data } = await api.lessons.createLesson({
        title,
        materials: dedupeLessonMaterials(materials),
      });
      return data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['lessons']);
      },
      onError: (error) => {
        toast.error(getLessonErrorMessage(error, 'Не удалось создать урок'));
      },
    },
  );

  const deleteLessons = useMutation(
    async (ids) => {
      await api.lessons.deleteLessons(ids);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['lessons']);
        toast.success('Выбранные уроки удалены');
      },
      onError: (error) => {
        toast.error(getLessonErrorMessage(error, 'Не удалось удалить уроки'));
      },
    },
  );

  return {
    lessons,
    createLesson,
    deleteLessons,
  };
};
